"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var LegislativeTypeResource = /** @class */ (function (_super) {
    tslib_1.__extends(LegislativeTypeResource, _super);
    function LegislativeTypeResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LegislativeTypeResource.endpoint = '/legislativetypes';
    LegislativeTypeResource.MODEL_NAME = 'legislativetype';
    return LegislativeTypeResource;
}(base_1.default));
exports.default = LegislativeTypeResource;
//# sourceMappingURL=legislativetype.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/legislativetype.js
// module id = wbCb
// module chunks = 0